import { css } from '@emotion/react'
import Select, { SingleValue } from 'react-select'

interface Props {
  value: number
  onChange: (perPage: number) => void
}

type OptionType = { label: string; value: number }

const PER_PAGE_OPTIONS: OptionType[] = [
  { label: '30件', value: 30 },
  { label: '50件', value: 50 },
  { label: '100件', value: 100 },
]

const style = css`
  width: 100px;
`

const customStyles = {
  control: (provided: any) => ({
    ...provided,
    height: '38px',
    minHeight: '38px',
    fontSize: '14px',
  }),
  valueContainer: (provided: any) => ({
    ...provided,
    height: '38px',
    padding: '0 8px',
  }),
  input: (provided: any) => ({
    ...provided,
    margin: '0',
    padding: '0',
  }),
  indicatorsContainer: (provided: any) => ({
    ...provided,
    height: '38px',
  }),
}

export const PerPageSelector = ({ value, onChange }: Props) => {
  const selectedOption = PER_PAGE_OPTIONS.find((opt) => opt.value === value)

  const handleChange = (newValue: SingleValue<OptionType>) => {
    if (newValue) {
      onChange(newValue.value)
    }
  }

  return (
    <Select
      css={style}
      value={selectedOption}
      options={PER_PAGE_OPTIONS}
      onChange={handleChange}
      isSearchable={false}
      styles={customStyles}
    />
  )
}
